import { VyStack } from '@vy/ui-design-system';
import { useEffect } from 'react';
import { useFormErrorNotificationContext } from '../../../../../../contexts/form-error-notification-context/form-error-notification-context';
import { CREATE_PLAN_TABS, type CreatePlanTab } from '../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { useChargeContext } from '../../charge-context';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import {
  AddUsageMeterSection,
  DiscountSection,
  PaymentSection,
  PricingSection,
  ScheduleSection,
  UpgradeOptionsSection,
} from '../sections';

export function SubscriptionVariant() {
  const { itemIndex: productIndex, isParentAgreement } = useChargeContext();
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();

  useEffect(() => {
    registerErrorField(`fixedProducts.${productIndex}.billingInterval`, CREATE_PLAN_TABS.serviceFees);
  }, [registerErrorField, productIndex]);

  if (isParentAgreement) {
    return (
      <VyStack sx={{ gap: 2.5 }}>
        <PricingSection showAutoPriceUplift={false} showAnrok={false} />
      </VyStack>
    );
  }

  return (
    <VyStack sx={{ gap: 2.5 }}>
      <PricingSection showSeats />
      <DiscountSection />
      <ScheduleSection showCadence showCalendarAlign showContractUpfront showFixedStartDate />
      <PaymentSection />
      <AddUsageMeterSection />
      <UpgradeOptionsSection />
    </VyStack>
  );
}
